const constants = {
 //PSLId: 11059,/*staging*/
 //PSLId: 19441, /*uat*/
 PSLId: 239848,
 PSCId: 12
}

export default constants;